import React from 'react';
import { Container } from 'react-bootstrap';
import SectionHeader from '../common/SectionHeader';
import { COMMON_STYLES, VIDEO_CONFIG } from '../../constants';

function Showreel() {
  // Video configuration for consistent styling
  const videoProps = {
    ...VIDEO_CONFIG.DEFAULT_PROPS,
    style: COMMON_STYLES.VIDEO_FRAME,
  };

  const videos = [
    {
      src: 'https://player.vimeo.com/video/1203262426?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="4th render-showreel',
      title: 'Showreel',
    },
  ];

  return (
    <Container fluid className="project-section">
      <SectionHeader
        title={
          <strong className="text-accent">My Showreel</strong>
        }
        description="Here is an overview of my animation projects, from the beginning of my study till now. This showreel includes parts of school assignments and personal projects. All made with love and commitment to self improvement."
      />

      {videos.map((video) => (
        <div key={video.src}>
          <div className="videoFrame">
            <iframe src={video.src} title={video.title} {...videoProps} />
          </div>
          <p style={COMMON_STYLES.DESCRIPTION_PADDING}>{video.description}</p>
        </div>
      ))}

      <script src="https://player.vimeo.com/api/player.js" />
    </Container>
  );
}

export default Showreel;
